import {GET_APPLICATION_MATRIX_LIST, UPDATE_SHORTLIST_FINALIST_MATRIX_LIST} from "../../utils/constants";

const initialState = [];
function applicationMatrixReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_APPLICATION_MATRIX_LIST:
      return [...state, payload];
    case UPDATE_SHORTLIST_FINALIST_MATRIX_LIST:
      return [...state,payload];
    default:
      return state;
  }
}
export default applicationMatrixReducer;
